import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MiniClipsService } from '../../../modules/learning-center/components/podcasts/miniClips.service';
import { PostHogService } from 'src/app/shared/services/posthog.service';
import { POSTHOG_EVENT_CARE_MINIS } from '../../constants/posthog-events.constants';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss']
})
export class VideoModalComponent implements OnInit {
  selectedVideoUrl: any;
  watchedTime: any;
  @ViewChild('myVideo') videoElement!: ElementRef;
  progress: number = 0;
  finalTime: number = 0;
  clipsData: any;
  clipsIndex: any;
  videoClipIndex: any;
  userMiniClipsData: any = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<VideoModalComponent>,
    private miniClipsService: MiniClipsService,
    private posthog: PostHogService,
    private deviceDetectorService: DeviceDetectorService
  ) { }

  ngOnInit(): void {
    this.clipsData = this.data.clipsData;
    this.clipsIndex = this.data.clipsIndex;
    this.videoClipIndex = this.data.videoClipIndex;
    this.selectedVideoUrl = this.clipsData[this.clipsIndex].miniClipData[this.videoClipIndex].videoUrl;

    for (let i = 0; i < this.clipsData.length; i++) {
      this.userMiniClipsData.push({
        miniClipVideosProgress: this.clipsData[i].miniClipVideosProgress, id: this.clipsData[i].id,
        status: this.clipsData[i].status, miniClipData: []
      });

      for (let j = 0; j < this.clipsData[i].miniClipData.length; j++) {
        this.userMiniClipsData[i].miniClipData.push({
          completed: this.clipsData[i].miniClipData[j].completed,
          progressTime: this.clipsData[i].miniClipData[j].progressTime
        })
      }
    }

    // console.log('this.userMiniClipsData', this.userMiniClipsData)
    this.trackVideoPlay();
  }

  playVideo() {
    const video: HTMLVideoElement = this.videoElement.nativeElement;

    const clip = this.clipsData[this.clipsIndex];
    const miniClip = clip.miniClipData[this.videoClipIndex];

    this.selectedVideoUrl = miniClip.videoUrl;

    video.src = this.selectedVideoUrl;
    video.load();

    setTimeout(() => {
      video.play().catch(err => console.log("Autoplay blocked:", err));
      this.trackVideoPlay();
    }, 200);
  }

  trackVideoPlay() {
    const currentRound = this.clipsData[this.clipsIndex];
    const currentVideo = currentRound.miniClipData[this.videoClipIndex];

    // Construct IDs
    const roundNumber = this.clipsIndex + 1;
    const videoNumber = this.videoClipIndex + 1;
    const videoName = currentVideo.name || `Video ${videoNumber}`; // Fallback if name is missing

    this.posthog.capture(POSTHOG_EVENT_CARE_MINIS, {
      'User email': localStorage.getItem('username'),
      'round_number-video_number-video_name': `${roundNumber}-${videoNumber}-${videoName}`,
      'device_type': this.deviceDetectorService.device,
      'role': localStorage.getItem('roleId')
    });
  }

  ngAfterViewInit() {
    const video: HTMLVideoElement = this.videoElement.nativeElement;

    // Add an event listener for the timeupdate event
    video.addEventListener('timeupdate', () => {
      this.progress = Math.floor(video.currentTime);
    });

    video.onended = () => {
      console.log("Current video ended");

      const currentClip = this.clipsData[this.clipsIndex];
      const totalVideos = currentClip.miniClipData.length;
      const nextVideoIndex = this.videoClipIndex + 1;

      // -----------------------------
      // CASE 1: NEXT VIDEO IN SAME CLIP
      // -----------------------------
      if (nextVideoIndex < totalVideos) {
        console.log("➡ Next video in same clip");
        this.closeVideoModal(true)
        this.videoClipIndex = nextVideoIndex;

        this.playVideo();
        return;
      }

      // -----------------------------
      // CASE 2: MOVE TO NEXT CLIP
      // -----------------------------
      const nextClipIndex = this.clipsIndex + 1;

      if (nextClipIndex < this.clipsData.length) {
        console.log("➡ Moving to next clip");
        this.closeVideoModal(true)
        this.clipsIndex = nextClipIndex;
        this.videoClipIndex = 0;

        this.playVideo();
        return;
      }

      // -----------------------------
      // CASE 3: NO MORE VIDEOS
      // -----------------------------
      console.log("✔ All clips & videos completed!");
      this.closeVideoModal(true)
      this.dialogRef.close(true);
    };

  }


  async closeVideoModal(isClose = false) {
    let existingProgress = this.userMiniClipsData[this.clipsIndex].miniClipData[this.videoClipIndex].progressTime;
    if (existingProgress < this.progress) {
      //   console.log('existingProgress', existingProgress)
      this.userMiniClipsData[this.clipsIndex].miniClipVideosProgress = this.userMiniClipsData[this.clipsIndex].miniClipVideosProgress - this.userMiniClipsData[this.clipsIndex].miniClipData[this.videoClipIndex].progressTime
      this.userMiniClipsData[this.clipsIndex].miniClipData[this.videoClipIndex].progressTime = this.progress;
      this.userMiniClipsData[this.clipsIndex].miniClipVideosProgress = this.userMiniClipsData[this.clipsIndex].miniClipVideosProgress + this.userMiniClipsData[this.clipsIndex].miniClipData[this.videoClipIndex].progressTime;
      if ((this.clipsData[this.clipsIndex].miniClipData[this.videoClipIndex].totalTime - 9) <= this.userMiniClipsData[this.clipsIndex].miniClipData[this.videoClipIndex].progressTime) {
        this.userMiniClipsData[this.clipsIndex].miniClipData[this.videoClipIndex].completed = true;
        this.userMiniClipsData[this.clipsIndex].miniClipData[this.videoClipIndex].completedAt = new Date();
      }
    }
    // console.log('this.clipData', this.userMiniClipsData);
    let isExistFalseStatus = this.userMiniClipsData[this.clipsIndex].miniClipData.some((item: any) => item.completed === false);
    // console.log('isExistFalseStatus', isExistFalseStatus);
    if (!isExistFalseStatus) {
      this.userMiniClipsData[this.clipsIndex].status = 'Completed';
    }
    await this.miniClipsService.updateMiniClipsProgress(this.userMiniClipsData);
    await this.miniClipsService.updateTotalMiniClipsProgress(this.clipsData[this.clipsIndex].totalDurationClips, this.clipsData[this.clipsIndex].id)
    if (!isClose) this.dialogRef.close(true);
  }

}

let miniClipsData: any = [
  {
    miniClipVideosProgress: 0,
    status: 'Not Started',
    miniClip: [{
      completed: false,
      progressTime: 0
    }]
  }
]
